<template>
  <div
    class="flex shrink-0 select-none items-center justify-center rounded-full font-racing uppercase leading-none tracking-wide"
    :class="size === 'sm' ? 'size-6 text-xs' : 'size-7 text-sm'"
    :style="palette"
    :title="name"
  >
    {{ initials }}
  </div>
</template>

<script setup lang="ts">
import '@fontsource/racing-sans-one';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    firstName?: string | null;
    lastName?: string | null;
    size?: 'sm' | 'md';
    userId?: string | null;
  }>(),
  { firstName: null, lastName: null, size: 'md', userId: null },
);

const name = computed(() => `${props.firstName ?? ''} ${props.lastName ?? ''}`.trim());

const initials = computed(() => {
  const first = props.firstName?.trim().charAt(0) ?? '';
  const last = props.lastName?.trim().charAt(0) ?? '';
  return `${first}${last}`.toUpperCase() || '?';
});

const palette = computed(() => {
  const seed = props.userId || name.value;
  let hash = 0;
  for (const char of seed) {
    hash = (Math.imul(31, hash) + char.charCodeAt(0)) | 0;
  }
  const hue = Math.abs(hash) % 360;
  return {
    backgroundColor: `hsl(${hue} 70% 88%)`,
    color: `hsl(${hue} 45% 32%)`,
  };
});
</script>
